<template>
    <!-- 数字展厅 -->
    <div class="guide-wrapper w-100">
        <!-- 列表头部 -->
       <!-- <div class="com-list-header">
            <el-form class="com-search-box" :model="form" ref="form" label-width="90px">
                <el-row type="flex" :gutter="20">

                    <el-col :span="6">
                        <el-form-item label="开放状态：">
                            <el-select v-model="form.type" placeholder="请选择开放状态">
                                <el-option v-for="item in statusList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="18">
                        <div class="tr">
                            <el-button type="primary" @click="getTableList">查询</el-button>
                            <el-button @click="resetForm('form')">重置</el-button>
                        </div>
                    </el-col>

                </el-row>
            </el-form>

        </div>-->

        <!-- 列表内容 -->
        <div class="com-list-content mt-0">

            <div class="button">
                <el-row type="flex">
                    <el-col>
                        <el-button class="el-primary-border" round @click="settingTime">
                            <svg-icon icon-class="add" />&nbsp;新增时段
                        </el-button>

                        <!-- <el-button type="danger" round @click="handleDelete1">
                            <i class="el-icon-delete" />&nbsp;删除
                        </el-button> -->
                    </el-col>
                    <el-popover placement="bottom" width="150" trigger="click">
                        <el-checkbox-group @change="handleCheck" v-model="checkList">
                            <el-checkbox :label="item.propName" v-for="(item, i) in checkLabels" :key="i"
                                style="display: block;">{{
                                    item.label }}</el-checkbox>
                        </el-checkbox-group>
                        <span class="icon-wrapper" slot="reference">
                            <svg-icon icon-class="shaixuan" class-name="icon-menu" />
                        </span>
                    </el-popover>

                    <el-popover class="pop-wrapper" placement="bottom" width="150" trigger="click">
                        <span class="icon-wrapper" slot="reference">
                            <svg-icon icon-class="export" class-name="icon-menu" />
                        </span>
                    </el-popover>

                    <span class="icon-wrapper">
                        <svg-icon icon-class="print" class-name="icon-menu" />
                    </span>

                </el-row>
            </div>
            <!-- 表格 -->
            <div class="table mt-20">
                <el-table ref="multipleTable" v-loading="listLoading" :row-key="(row) => { return row.id }" stripe
                    :data="tableData" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column>
                    <template v-for="item in checkLabels">
                        <el-table-column v-if="item.show" :prop="item.propName" :label="item.label" :key="item.label"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.column.property === 'time'">
                                    {{ scope.row.startTime }} ~ {{ scope.row.endTime }}
                                </span>

                                <span v-else-if="scope.column.property === 'openTimes'">
                                    <el-tag v-for="(item, index) in scope.row.openTimeArr" :key="index" type="success">{{
                                        item | filterOpenTime(weeks) }}</el-tag>
                                </span>

                                <span v-else>{{ scope.row[scope.column.property] }}</span>

                            </template>

                        </el-table-column>
                    </template>
                    <!-- 操作 -->
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
                            <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>

                        </template>
                    </el-table-column>
                </el-table>

                <div class="pagination-container paging">
                    <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total"
                        background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" />
                </div>
            </div>
        </div>
        <dialog-time-period ref="dialogTimePeriod" @refresh="getData"></dialog-time-period>
    </div>
</template>
  
<script>
import dialogTimePeriod from './dialogs/dialog-time-period'

export default {
    data() {
        return {
            form: {
                name: '',
            },
            value1: '',
            weeks: [{ label: '周一', value: '1' }, { label: '周二', value: '2' }, { label: '周三', value: '3' }, { label: '周四', value: '4' }, { label: '周五', value: '5' }, { label: '周六', value: '6' }, { label: '周日', value: '7' }],

            cardList: [{ value: '1', label: '身份证' }, { value: '2', label: '护照' }, { value: '3', label: '港澳台通行证' }, { value: '4', label: '外国人永居证' }],
            statusList: [{ value: '1', label: '手动取消' }, { value: '2', label: '待参观' }, { value: '3', label: '已参观' }, { value: '4', label: '已过期' }, { value: '5', label: '待审核' }, { value: '6', label: '已拒绝' }, { value: '7', label: '系统关闭' }, { value: '8', label: '已退票' }],
            // checkLabels: [{ label: '订单号', propName: 'name' }, { label: '日期', propName: 'date' }, { label: '开始时间', propName: '' }, { label: '结束时间', propName: '' }, { label: '用户名', propName: '' }, { label: '人数', propName: '' }, { label: '姓名', propName: '' }, { label: '手机号', propName: '' }, { label: '证件类型', propName: '' }, { label: '证件号码', propName: '' }, { label: '票价类型', propName: '' }, { label: '票价', propName: '' }, { label: '订单状态', propName: '' }, { label: '入馆/取消时间', propName: '' }],
            checkLabels: [{ label: '时段', show: true, propName: 'time' }, { label: '开放票数', show: true, propName: 'openNum' }, { label: '开放场次', show: true, propName: 'openTimes' }],
            checkList: [],
            listLoading: true,
            listQuery: {
                currentPage: 1,
                size: 10
            },
            total: 0,
            tableData: [],
            chooseRowIds: '',
        }
    },
    filters: {
        filterOpenTime(val, weeks) {
            let tempObj
            weeks.map(item => {
                if (val == item.value) {
                    tempObj = item
                }
            })
            if (tempObj) {
                return tempObj.label
            } else {
                return null
            }
        },
    },

    watch: {
        $route: {
            handler(to, from) {
                this.total = 0
                this.value1 = []
                this.chooseRowIds = ''
                this.listQuery = { currentPage: 1, size: 10 }
                this.setHead()
                this.getData()
            },
            immediate: true
        }
    },

    components: { dialogTimePeriod },
    methods: {
        // 项目列表
        getData() {
            this.listLoading = true
            this.tableData = []
            this.$api.appointSetting.getList({
                orgId: this.$route.query.orgId,
                ...this.listQuery
            }).then(res => {
                this.listLoading = false
                if (res.success) {
                    this.tableData = res.result
                    this.tableData.map(item => {
                        item.openTimeArr = item.openTimes.split(',')
                    })
                    this.total = res.page.allRow

                } else {
                    this.$message.error(res.message || '系统异常')
                }
            })
        },

        settingTime() {
            this.$refs.dialogTimePeriod.init('add')
        },

        handleSelectionChange(list) {
            let arr = []
            list.forEach(item => {
                arr.push(item.id)
            })
            this.chooseRowIds = arr.join(',')
        },

        setHead() {
            this.checkLabels.map(item => {
                this.checkList.push(item.propName)
            })
        },

        // 动态修改表头
        handleCheck(key) {
            for (let i = 0; i < this.checkLabels.length; i++) {
                if (this.checkList.includes(this.checkLabels[i].propName)) {
                    this.checkLabels[i].show = true;
                } else {
                    this.checkLabels[i].show = false;

                }
            }
        },


        // 重置查询
        resetForm() {
            this.form = {
                name: '',
            }
            this.listQuery.currentPage = 1
            this.getData()
        },

        // 查询
        getTableList() {
            this.listQuery.currentPage = 1
            this.getData()
        },

        handleEdit(obj) {
            this.$refs.dialogTimePeriod.init('edit', obj.id)
        },

        // 删除
        handleDelete(obj) {
            this.$common.confirm1('是否确认删除?').then(() => {
                this.$api.appointSetting.deleteTime({ id: obj.id }).then(res => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        this.getData()
                    } else {
                        this.$message.error(res.message || '系统异常')
                    }
                }).catch(() => { })
            })
        },


        // 删除
        handleDelete1() {
            this.$common.confirm1('是否确认删除?').then(() => {
                this.$api.appointSetting.deleteTime({ id: this.chooseRowIds }).then(res => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        this.getData()
                    } else {
                        this.$message.error(res.message || '系统异常')
                    }
                }).catch(() => { })
            })
        },

        // 表格分页
        handleSizeChange(val) {
            this.listQuery.size = val
            this.getData()
        },
        // 点击序号
        handleCurrentChange(val) {
            this.listQuery.currentPage = val
            this.getData()
        },


        guide(obj) {
            this.$router.push({
                path: '/applet-management/guide-management',
                query: { guideId: obj.id }
            })
        },
    },

    beforeUpdate() {
        this.$nextTick(() => { //在数据加载完，重新渲染表格
            this.$refs['multipleTable'].doLayout()
        })
    },

    created() {
    }
}
</script>
  
<style lang="scss" scoped>
.guide-wrapper {
    .com-list-header {
        padding-right: 30px;

        .el-row--flex {
            flex-wrap: wrap;
        }
    }

    .com-list-content {
        .el-row--flex {
            justify-content: end;
        }
    }

    .icon-wrapper {
        display: flex;
        width: fit-content;
        padding: 6px;
        margin-left: 20px;
        border: 1px solid #ccc;
        justify-content: center;
        align-items: center;

        &:hover {
            cursor: pointer;
            border: 1px solid #999;
            transition: .5s all;

        }

        .icon-menu {
            font-size: 20px;
        }
    }

    /deep/ .el-form-item {
        margin-bottom: 20px;

        &.avatar-uploader-form {
            display: flex;
            flex-direction: column;

            /deep/ .el-form-item__content {
                margin-left: 0 !important;
            }

            .avatar-uploader {
                width: 50%;
                border: 1px dashed #8c939d;
                height: 120px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .avatar {
                    width: 100%;
                    height: 120px;
                    object-fit: contain;
                }

                .el-icon-plus {
                    font-size: 20px;
                }

                .el-upload__text {
                    line-height: 1;
                }
            }

            .tip-img {
                left: 0;
            }
        }
    }

    /deep/ .el-button--danger span {
        color: #fff;
    }
}
</style>